import React from 'react';
import { companyInfo } from '../../data/mockData';

export const HeroFounderTag = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '1rem',
      marginBottom: '2.5rem',
      flexWrap: 'wrap'
    }}
  >
    <img
      src="https://customer-assets.emergentagent.com/job_dba9b77f-2bec-4d59-9c0d-9f2fc088db35/artifacts/qmnmr0x0_Photo.jpeg"
      alt={`${companyInfo.founder} — Founder, SS Consultancy`}
      style={{
        width: '3.75rem',
        height: '3.75rem',
        borderRadius: '50%',
        objectFit: 'cover',
        border: '2px solid var(--accent-gold)'
      }}
    />
    <div style={{ textAlign: 'left' }}>
      <div style={{ fontSize: '1rem', fontWeight: 600, color: 'var(--text-white)', marginBottom: '0.15rem' }}>
        {companyInfo.founder}, MBA Finance
      </div>
      <div style={{ fontSize: '0.825rem', color: 'rgba(255,255,255,0.78)', fontWeight: 500 }}>
        Founder · {companyInfo.arn}
      </div>
    </div>
  </div>
);
